import {
  Component,
  OnInit,
  NgModule,
  EventEmitter,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxDropDownButtonModule,
  DxTabPanelModule,
  DxValidationGroupModule,
  DxScrollViewModule,
} from 'devextreme-angular';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { StatusIndicatorComponent } from '../status-indicator/status-indicator.component';
import { TaskFormComponent } from '../task-form/task-form.component';
import { Task } from '../task';
import { TaskService } from '../../planing.service';
import { CardActivitiesComponent } from '../card-activities/card-activities.component';
import { CardNotesComponent } from '../card-notes/card-notes.component';
import { CardMessagesComponent } from '../card-messages/card-messages.component';
import { Router } from '@angular/router';

@Component({
  selector: 'dk-planning-task-details',
  templateUrl: './planning-task-details.component.html',
  styleUrls: ['./planning-task-details.component.scss'],
  standalone: true,
  imports: [
    DxButtonModule,
    DxDropDownButtonModule,
    DxTabPanelModule,
    DxValidationGroupModule,
    DxToolbarModule,
    CardActivitiesComponent,
    CardNotesComponent,
    CardMessagesComponent,
    TaskFormComponent,
    StatusIndicatorComponent,
    DxScrollViewModule,
    CommonModule,
  ],
})
export class PlanningTaskDetailsComponent implements OnInit {
  task: Task;

  taskId = 1;

  taskName = 'Loading...';

  isLoading = false;
  @Output() private closePopup = new EventEmitter<string>();

  constructor(private service: TaskService, private router: Router) {}

  loadData = () => {
    this.service.getTask(this.taskId).subscribe((data) => {
      this.task = data;
      this.taskName = data.text;
      this.isLoading = false;
    });
  };

  ngOnInit(): void {
    this.loadData();
  }

  refresh = () => {
    this.isLoading = true;
    this.loadData();
  };

  closeClick() {
    this.closePopup.emit(null);
  }
}
